<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nom et Postnom</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.nom"
             class="form-control"
             name="arbitre_nom"
             placeholder="Entrez nom de l'arbitre"
             type="text">
      <input v-model="dataForm.postnom"
             class="form-control"
             name="arbitre_postnom"
             placeholder="Postnom de l'arbitre"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Prénom</label>
      </div>
      <input v-model="dataForm.prenom"
             class="form-control"
             name="arbitre_prenom"
             placeholder="Entrez le prénom de l'arbitre"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Photo Passeport</label>
      </div>
      <input ref="fileToUpload"
             @change="handleFileToUpload"
             lang="fr"
             type="file"
             class="form-control"
             accept=".png, .jpeg, .jpg">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Description</label>
      </div>
      <textarea v-model="dataForm.description"
                class="form-control"
                name="arbitre_description"
                placeholder="Entrez une courte description de l'arbitre">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Date de naissance</label>
      </div>
      <input v-model="dataForm.date_naissance"
             class="form-control"
             name="arbitre_date_naissance"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nationalité</label>
      </div>
      <select v-model="dataForm.nationalite"
              class="custom-select"
              name="arbitre_nationalite">
        <option :value="arbitre.nationalite">
          {{ arbitre.nationalite }}
        </option>
        <option :value="arbitre.nationalite">-------------------------------------</option>
        <option :key="'nationalite'+idx"
                :value="nationalite.value"
                v-for="(nationalite, idx) in getNationalites">{{ nationalite.nationalites }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nombre des matchs arbitrés</label>
      </div>
      <input v-model="dataForm.nombre_matchs_arbitres"
             class="form-control"
             name="arbitre_nombre_matchs_arbitres"
             placeholder="Entrez le nombre total des matchs arbitrés par l'arbitre"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Niveau de l'arbitre</label>
      </div>
      <select v-model="dataForm.niveau"
              class="custom-select"
              name="arbitre_niveau">
        <option :value="arbitre.niveau">
          {{ arbitre.niveau }}
        </option>
        <option :value="arbitre.niveau">-------------------------------------</option>
        <option :key="'niveau'+idx"
                :value="niveau"
                v-for="(niveau, idx) in getNiveauxArbitres">{{ niveau }}</option>
      </select>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    arbitre: {
      type: Object
    }
  },
  data() {
    return {
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        postnom: '',
        prenom: '',
        photo_passeport: '',
        description: '',
        commentaires: '',
        historique: '',
        date_naissance: '',
        nombre_matchs_arbitres: '',
        niveau: '',
        nationalite: '',
        table: 'arbitres',
        table_id: this.arbitre.arbitre_id,
      },
      file: '',
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosPutData',
      'axiosPostFileData',
      'axiosRemoveFileData',
    ]),
    handleFileToUpload(){
      this.file = this.$refs.fileToUpload.files[0];
    },
    uploadFile () {
      let formData = new FormData()
      let fileName = ''
      if(this.dataForm.nom && this.dataForm.postnom && this.dataForm.prenom){
        fileName = this.dataForm.prenom.toLowerCase() + '_' +
            this.dataForm.postnom.toLowerCase() + '_' +
            this.dataForm.nom.toLowerCase() + '_' + Math.floor(Math.random() * 1000000) + 1
      }
      formData.append('fileToUpload', this.file)
      formData.append('fileName', fileName)
      formData.append('to', "arbitres")
      this.axiosPostFileData(formData)
          .then(data => {
            this.dataForm.photo_passeport = data[2];
            this.resetDefaultValues()
            if(!this.dataForm.photo_passeport)
              this.dataForm.photo_passeport = this.arbitre.photo_passeport
            this.axiosPutData(this.dataForm)
                .then((data) => {
                  if(data.status === 204)
                    this.messageSuccess = "Arbitre modifié avec succès !"
                  else
                    this.messageFailure = "Une erreur est survenue lors de la modification de l'arbitre !"
                })
                .catch((error) => {
                  this.messageFailure = "Une erreur est survenue lors de la modification de l'arbitre !"
                })
          })
          .catch(data => {
          })
    },
    onSubmit() {
      this.uploadFile()
    },
    postData(){
      //
    },
    resetDefaultValues() {
      if(this.dataForm.nom === '')
        this.dataForm.nom = this.arbitre.nom
      if(this.dataForm.postnom === '')
        this.dataForm.postnom = this.arbitre.postnom
      if(this.dataForm.prenom === '')
        this.dataForm.prenom = this.arbitre.prenom
      if(this.dataForm.photo_passeport === '')
        this.dataForm.photo_passeport = this.arbitre.photo_passeport
      if(this.dataForm.description === '')
        this.dataForm.description = this.arbitre.description
      if(this.dataForm.date_naissance === '')
        this.dataForm.date_naissance = this.arbitre.date_naissance
      if(this.dataForm.nombre_matchs_arbitres === '')
        this.dataForm.nombre_matchs_arbitres = this.arbitre.nombre_matchs_arbitres
      if(this.dataForm.niveau === '')
        this.dataForm.niveau = this.arbitre.niveau
      if(this.dataForm.nationalite === '')
        this.dataForm.nationalite = this.arbitre.nationalite
    },
    setDefaultValues() {
      const arbitre = Object.assign({}, this.arbitre);
      this.dataForm.nom = arbitre.nom
      this.dataForm.postnom = arbitre.postnom
      this.dataForm.prenom = arbitre.prenom
      this.dataForm.photo_passeport = arbitre.photo_passeport
      this.dataForm.description = arbitre.description
      this.dataForm.date_naissance = arbitre.date_naissance
      this.dataForm.nombre_matchs_arbitres = arbitre.nombre_matchs_arbitres
      this.dataForm.niveau = arbitre.niveau
      this.dataForm.nationalite = arbitre.nationalite
    }
  },
  computed: {
    ...mapGetters([
      'getNationalites',
      'getNiveauxArbitres',
      'getBaseFileURL'
    ])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/arbitres/components/Update.vue